import script from "./ManagementInfo.vue?vue&type=script&lang=ts&setup=true"
export * from "./ManagementInfo.vue?vue&type=script&lang=ts&setup=true"

import "./ManagementInfo.vue?vue&type=style&index=0&id=100552ca&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2780876773/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-100552ca"]])

export default __exports__